import { render } from "./GoldcastButton.vue?vue&type=template&id=acccc07a&scoped=true"
import script from "./GoldcastButton.vue?vue&type=script&lang=js"
export * from "./GoldcastButton.vue?vue&type=script&lang=js"

import "./GoldcastButton.vue?vue&type=style&index=0&id=acccc07a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.42_vue@3.3.4_webpack@5.99.6_esbuild@0.25.3_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acccc07a"]])

export default __exports__